import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IUserTask } from '@obvious.tech/constellation'

export const UserTask = defineEntity('UserTask', {
  endpoint: 'tasks/api/UserTask',
  schema: SNoop<IUserTask>(),
})
